import { PublicationContentType } from '@app/entities/enums/multimedia/content-status-types.enum';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { Publication } from './publication.model';

export class News extends Publication {
  contentType = PublicationContentType.NEWS;
  source: string;

  constructor(data: MSafeAny) {
    super(data);
    this.source = data.source;
  }
}
